import {Button, Typography} from 'antd';
import CardItem from './CardItem';
const {Text} = Typography;

const CartItems = ({updateCartItems, cartItems, productItems, currencySymbol}) => {
  console.log(cartItems, 'cartItems here.');
  console.log(productItems, 'productItems here.');
  const cartItemsComponents = cartItems.map((item, index) => {
    // const product = productItems.find(
    //   product => product.productId === item.product_id
    // );
    // const variant = product?.variants.find(
    //   variant => variant.id === item.variant_id
    // );
    return (
      <CartItem
        key={`${item?.product_id}-${item?.variant_id}-${index}`}
        title={item?.title}
        price={item?.price}
        quantity={item?.quantity}
        variantTitle={item?.variantTitle}
        sku={item?.sku}
        updateCartItems={updateCartItems}
        variantId={item?.variant_id}
        productId={item?.product_id}
      />
    );
  });
  return (
    <CardItem>
      <Text
        style={{
          color: '#1F2D3D',
          fontWeight: 600,
          fontSize: '16px',
        }}
      >
        Products in Cart
      </Text>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '20px',
        }}
      >
        {cartItemsComponents}
      </div>
    </CardItem>
  );
};

const CartItem = ({
  title,
  price,
  quantity,
  variantTitle,
  sku,
  updateCartItems,
  variantId,
  productId,
  currencySymbol,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          width: 'calc(100% - 100px)',
        }}
      >
        <Text
          style={{
            fontSize: '14px',
            fontWeight: '700',
            lineHeight: '16px',
            color: '#1F2D3D',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            maxWidth: '90%',
          }}
        >
          {title}
        </Text>
        {sku && (
          <Text
            style={{
              fontSize: '12px',
              fontWeight: '500',
              lineHeight: '16px',
              color: '#6E6E6E',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: '90%',
            }}
          >
            SKU: {sku}
          </Text>
        )}
        <div style={{ display: 'flex' }}>
          <Text
            style={{
              fontSize: '13px',
              fontWeight: '600',
              lineHeight: '16px',
              color: '#1F2D3D',
            }}
          >
            {currencySymbol}{price}
          </Text>
          <Text
            style={{
              fontSize: '12px',
              fontWeight: '500',
              lineHeight: '16px',
              color: '#6E6E6E',
              marginLeft: '5px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              maxWidth: '100px',
            }}
          >
            {variantTitle}
          </Text>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          borderRadius: '5px',
          overflow: 'hidden',
          width: '96px',
        }}
      >
        <Button
          onClick={() => updateCartItems(variantId, productId, quantity - 1)}
          style={{
            backgroundColor: '#EDF6FF',
            width: '32px',
            height: '28px',
            borderRadius: 0,
            border: 'none',
          }}
        >
          <img width={14} height={14} src={'/minusIcon.svg'} alt="minus" />
        </Button>
        <div
          style={{
            background: '#369eff',
            width: '32px',
            height: '28px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: '12px',
            fontWeight: '600',
            lineHeight: '16px',
          }}
        >
          {quantity}
        </div>
        <Button
          onClick={() => updateCartItems(variantId, productId, quantity + 1)}
          style={{
            backgroundColor: '#EDF6FF',
            width: '32px',
            height: '28px',
            borderRadius: 0,
            border: 'none',
          }}
        >
          <img width={14} height={14} src={'/plusIcon.svg'} alt="plus" />
        </Button>
      </div>
    </div>
  );
};

export default CartItems;
